import React from 'react';
import { Loading } from '@ui';
import { Outlet, useParams } from 'react-router-dom';
import { useGetMonitoringFormSingleQuery } from '@app/store/api/qm-module/qm-manage/qm-manage-monitoring-forms.api';
import { NotFoundedPage } from '@app/pages';
import { MonitoringFormInfoType } from '@app/interfaces/qm-module/qm-manage/qm-monitoring-forms.type';
import { useGetAnalyticProjectsForLastProjectsQuery } from '@app/store/api/analytics-projects.api';
import { ProjectItem } from '@app/interfaces/analytics';
import { useGetChatAnalyticProjectsForLastProjectsQuery } from '@app/store/api/chat-api/chat-analytic.api';

import { usePermissionCheck } from '@app/hooks/use-permission';

import { userPermissions } from '@app/utils/user-permissions';

import MonitoringFormsSettingsHeaderWithStatuses from './blocks/monitoring-forms-settings-header-with-statuses';
import MonitoringFormsSettingsNavigation from './blocks/monitoring-forms-settings-navigation';

export type MonitoringFormSettingsOutletType = {
  monitoringFormData?: MonitoringFormInfoType | undefined;
  analyticsProjects: ProjectItem[] | undefined;
};

const MonitoringFormsSettingsOutlet = () => {
  // const { t } = useTranslation('pages.qmManage.monitoring_forms.createMonitoringForm');
  const { id } = useParams();
  const chatPermission = usePermissionCheck({
    permissions: 'display',
    tag: userPermissions.display.displayChats,
  });

  const {
    data: monitoringFormData,
    isError,
    isLoading,
  } = useGetMonitoringFormSingleQuery({ id: id || '' }, { skip: !id });
  const { data: analyticsProjectsVoice, isLoading: voiceApProjectsLoading } =
    useGetAnalyticProjectsForLastProjectsQuery();
  const { data: analyticsProjectsChat, isLoading: chatApProjectsLoading } =
    useGetChatAnalyticProjectsForLastProjectsQuery(undefined, { skip: chatPermission });

  const apLoading = chatApProjectsLoading || voiceApProjectsLoading;

  const analyticsProjects = [...(analyticsProjectsChat || []), ...(analyticsProjectsVoice || [])];
  const monitoringFormOutlet: MonitoringFormSettingsOutletType = {
    monitoringFormData,
    analyticsProjects,
  };
  if (isError) return <NotFoundedPage />;
  if (isLoading || apLoading) return <Loading />;
  return (
    <div>
      <MonitoringFormsSettingsHeaderWithStatuses monitoringFormData={monitoringFormData} />
      <MonitoringFormsSettingsNavigation />
      <Outlet context={monitoringFormOutlet} />
    </div>
  );
};

export default MonitoringFormsSettingsOutlet;
